export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var CreatableListInputMode;
(function (CreatableListInputMode) {
    CreatableListInputMode["INPUT"] = "INPUT";
    CreatableListInputMode["TEXTAREA"] = "TEXTAREA";
})(CreatableListInputMode || (CreatableListInputMode = {}));
export var CreatableListValueSeparator;
(function (CreatableListValueSeparator) {
    CreatableListValueSeparator["COMMA"] = "COMMA";
    CreatableListValueSeparator["SEMICOLON"] = "SEMICOLON";
    CreatableListValueSeparator["TAB"] = "TAB";
    CreatableListValueSeparator["NEWLINE"] = "NEWLINE";
})(CreatableListValueSeparator || (CreatableListValueSeparator = {}));
